import { batch } from "solid-js";
import type { SetStoreFunction } from "solid-js/store";
import type { GlobalBootstrapCache, GlobalStore } from "./types";

export async function hydrateCachesWhileStarting(input: {
  initializers: Array<Promise<unknown> | unknown>
  active: () => boolean
  hydrate: () => void
  start: () => void
}) {
  if (!input.active()) return
  input.start()
  await Promise.allSettled(input.initializers.map((initializer) => Promise.resolve(initializer)))
  if (!input.active()) return
  input.hydrate()
}

export function hydrateGlobalStore(
  setStore: SetStoreFunction<GlobalStore>,
  cache: GlobalBootstrapCache,
) {
  batch(() => {
    setStore("path", cache.path);
    setStore("project", cache.project);
    setStore("config", cache.config);
    setStore("machineWorkspace", cache.machineWorkspace);
  });
}
